import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Chart from "react-apexcharts";

const shrinkNumber = (value) => {
    let result = value;
    if (parseFloat(result) >= 1000000) {
        result = `${(result / 1000000).toFixed(0)}M`
    } else if (parseFloat(result) >= 1000) {
        result = `${(result / 1000).toFixed(0)}K`
    } else {
        result = result.toLocaleString()
    }
    return result
}

const CATALOG_TAB = 'catalog';
const LEADS_TAB = 'businesses';
const PEOPLE_TAB = 'people';

function MCharts(props) {
    const [isCatalogView, setIsCatalogView] = useState(props.mode === CATALOG_TAB);
    const [isLeadsView, setIsLeadsView] = useState(props.mode === LEADS_TAB);
    const [isPeopleView, setIsPeopleView] = useState(props.mode === PEOPLE_TAB);
    const [barOptions, setBarOptions] = useState(initBarOptions(0, []));
    const [barSeries, setBarSeries] = useState(initBarSeries([]));
    const [siteOptions, setSiteOptions] = useState(initBarOptions(0, []));
    const [siteSeries, setSiteSeries] = useState(initBarSeries([]));
    const [socialOptions, setSocialOptions] = useState(initBarOptions(0, []));
    const [socialSeries, setSocialSeries] = useState(initBarSeries([]));
    const [presenceOptions, setPresenceOptions] = useState(initPresenceOptions([]));
    const [presenceSeries, setPresenceSeries] = useState(initPresenceSeries([]));
    const [reputationOptions, setReputationOptions] = useState(initReputationOptions([]));
    const [reputationSeries, setReputationSeries] = useState(initReputationSeries([]));
    const [pieOptions, setPieOptions] = useState(initPieOptions([]));
    const [pieSeries, setPieSeries] = useState(initPieSeries([]));
    const [treemapOptions, setTreemapOptions] = useState(initTreemapOptions([]));
    const [treemapSeries, setTreemapSeries] = useState(initTreemapSeries([]));
    const [top10Group, setTop10Group] = useState(''); 
    const [peopleSumOptions, setPeopleSumOptions] = useState(initBarOptions(0, []));
    const [peopleSumSeries, setPeopleSumSeries] = useState(initBarSeries([]));
    const [peopleLvlOptions, setPeopleLvlOptions] = useState(initBarOptions(0, []));
    const [peopleLvlSeries, setPeopleLvlSeries] = useState(initBarSeries([]));
    const [peopleFunOptions, setPeopleFunOptions] = useState(initBarOptions(0, []));
    const [peopleFunSeries, setPeopleFunSeries] = useState(initBarSeries([]));

    function initBarOptions(chartMode, data) {
        return {
            tooltip: {
                enabled: true,
                y: {
                    formatter: function (val, opt) {
                        return (val > 0) ? val.toLocaleString() : ''
                    }
                },
            },
            plotOptions: {
                bar: {
                    barHeight: '90%',
                    distributed: true,
                    horizontal: true,
                    borderRadius: 0,
                    dataLabels: { position: 'bottom' }
                }
            },
            colors: ['#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e', '#f48024', '#69d2e7', '#8024f4', '#d2e769' ],
            dataLabels: {
                enabled: true,
                enabledOnSeries: true,
                textAnchor: 'start',
                offsetX: 10,
                offsetY: 0,
                style: { colors: ['#000'] },
                formatter: function (val, opt) {
                    return (val > 0) ? val.toLocaleString() : ''
                },
                dropShadow: { enabled: false, color: '#fff' }
            },
            xaxis: {
                categories: data ? data : [],
                labels: {
                    trim: true,
                    formatter: function (value) {
                        let result = parseInt(value);
                        if (value >= 1000000) {
                            result = `${value / 1000000}M`
                        } else if (value >= 1000) {
                            result = `${value / 1000}K`
                        }
                        return result;
                      }
                }
            },
            yaxis: {
                labels: { show: true }
            },
            legend: { 
                show: false, 
                position: 'bottom' 
            },
            chart: {
                events: {
                    dataPointSelection: function(event, chartContext, config) {
                        props.lfu({mode: chartMode, index: config.dataPointIndex, value: data[config.dataPointIndex]})
                    }
                },
                toolbar: { show: false }
            }
        }
    }

    function initBarSeries(data) {
        return [{
            name: isPeopleView ? "People" : "Businesses",
            data: data ? data : []
        }]
    }

    function initPresenceOptions(data) {
        return {
            tooltip: {
                enabled: true,
                y: {
                    formatter: function (val, opt) {
                        return (val > 0) ? val.toLocaleString() : ''
                    }
                },
            },
            plotOptions: {
                pie: {
                    startAngle: 0,
                    endAngle: 360,
                }
            },
            fill: {
                type: 'gradient',
            },
            dataLabels: {
                enabled: false,
                enabledOnSeries: false,
                textAnchor: 'end',
                formatter: function (val, opts) {
                        let result = opts.w.globals.series[opts.seriesIndex];
                        return shrinkNumber(result)
                },
            },
            legend: {
                show: false,
                position: 'left'
            },
            labels: data ? data : [],
            dataLabels: {
                formatter(val, opts) {
                  const name = opts.w.globals.labels[opts.seriesIndex]
                  return [name, val.toFixed(1) + '%']
                },
            },
            chart: {
                type: "pie",
                events: {
                    dataPointSelection: function(event, chartContext, config) {
                        passPresenceFilter(data[config.dataPointIndex])
                    },
                }
            },
            theme: {
                palette: 'palette2',
            }
          }
    }

    function initPresenceSeries(data) {
        return data ? data : []
    }
  
    function initReputationOptions(data) {
        return {
            tooltip: {
                enabled: true,
                y: {
                    formatter: function (val, opt) {
                        return (val > 0) ? val.toLocaleString() : ''
                    }
                },
            },
            plotOptions: {
                pie: {
                    startAngle: 0,
                    endAngle: 360,
                }
            },
            fill: {
                type: 'gradient',
            },
            dataLabels: {
                enabled: false,
                enabledOnSeries: false,
                textAnchor: 'end',
                formatter: function (val, opts) {
                        let result = opts.w.globals.series[opts.seriesIndex];
                        return shrinkNumber(result)
                },
            },
            legend: {
                show: false,
                position: 'left'
            },
            labels: data ? data : [],
            dataLabels: {
                formatter(val, opts) {
                  const name = opts.w.globals.labels[opts.seriesIndex]
                  return [name, val.toFixed(1) + '%']
                },
            },
            chart: {
                type: "pie",
                events: {
                    dataPointSelection: function(event, chartContext, config) {
                        passReputationFilter(data[config.dataPointIndex])
                    },
                }
            },
            theme: {
                palette: 'palette4',
            }
          }
    }

    function initReputationSeries(data) {
        return data ? data : []
    }

    function initPieOptions(data) {
        return {
            tooltip: {
                enabled: true,
                y: {
                    formatter: function (val, opt) {
                        return (val > 0) ? val.toLocaleString() : ''
                    }
                },
            },
            plotOptions: {
                pie: {
                    startAngle: 0,
                    endAngle: 360,
                    donut: {
                        size: '50%',
                        labels: {
                            show: false,
                            total: {
                                show: false,
                                // label: 'Lead Count',
                                // showAlways: true,
                            }
                        }
                    }
                }
            },
            fill: {
                type: 'gradient',
            },
            dataLabels: {
                enabled: true,
                enabledOnSeries: true,
                textAnchor: 'end',
                formatter: function (val, opts) {
                        let result = opts.w.globals.series[opts.seriesIndex];
                        return shrinkNumber(result)
                },
            },
            legend: {
                position: 'left'
            },
            labels: data ? data : [],
            chart: {
                type: "donut",
                events: {
                    dataPointSelection: function(event, chartContext, config) {
                        passPieFilter(data[config.dataPointIndex])
                    },
                }
            }
        }
    }

    function initPieSeries(data) {
        return data ? data : []
    }

    function initTreemapOptions(data) {
        return {
            chart: {
                type: 'treemap',
                toolbar: {
                  show: false,
                },
                animations: {
                  enabled: false,
                },
                events: {
                    click: function(event, chartContext, config) { 
                        const dataPointIndex = config.dataPointIndex;
                        const seriesIndex = config.seriesIndex;
                        if (dataPointIndex !== -1) {
                            const data = config.config.series[seriesIndex].data[dataPointIndex];
                            passPieFilter(data?.x);
                        }
                    },
                }
              },
              dataLabels: {
                enabled: true,
                formatter: function (text, op) {
                    let result = op.value;
                    return [text, shrinkNumber(result)]
                },
              },
              plotOptions: {
                treemap: {
                  distributed: true,
                  enableShades: false,
                  dataLabels: {
                     format: "scale",
                  },
                }
              },
              tooltip: {
                enabled: true,
              },                    
        }
    }

    function initTreemapSeries(data) {
        return [{data: data ? data : []}]
    }
  
    function passPieFilter(value) {
        const index = props.groupByCategory ? 98 : 99;
        props.lfu({index: index, value: value}); 
    }
  
    function passPresenceFilter(value) {
        const index = 91;
        props.lfu({mode: 0, index: index, value: value}); 
    }
  
    function passReputationFilter(value) {
        const index = 92;
        props.lfu({mode: 0, index: index, value: value}); 
    }
    
    useEffect(() => {
        const isUserCategoryGroup = props.isucg;
        const filterCategoryGroup = props.categorygroup?.value ?? '';
        const filterMultipleCategories = props.multipleCategories ?? '';
        const filterCategory = props.category ?? '';
        const filterCountry = props.country ?? '';
        const filterState = `'${props.state}'` ?? "''";
        const selectedCategory = ''; // props.selectedOnly ? (isLeadsView || isPeopleView) ? props.catalog?.category_en ?? '' : '' : '';
        const selectedState = ''; // props.selectedOnly ? (isLeadsView || isPeopleView) ? props.catalog?.state ?? '' : '' : '';
        const filterModel = (isLeadsView || isPeopleView) ? props.filtermodel : undefined;
        const countsUrl = isLeadsView ? '/getmegaleadcounts' : isPeopleView ? '/getmegapeoplecounts' : '/getmegacatalogcounts';

        const groupByCategory = isLeadsView ? props.groupByCategory : !props.groupByCategory;
        const top10Url = groupByCategory ? '/getmegacatalogtop10categories' : '/getmegacatalogtop10states';
        setTop10Group(groupByCategory ? 'category' : 'state' );

        props.ucd(true);
        axios.post(countsUrl, { isUserCategoryGroup, filterCategoryGroup, filterMultipleCategories, filterCategory, filterCountry, filterState, selectedCategory, selectedState, filterModel })
        .then(res => {
            if (isCatalogView || isLeadsView) {
                setBarOptions(initBarOptions(0, ['Categories', 'States/Territories', 'Businesses', 'Branches', 'Addresses', 'Phone Numbers', 'Websites', 'Emails', 'People']));
                setBarSeries(initBarSeries([
                    res.data[0].Categories,
                    res.data[0].States,
                    res.data[0].Total_Leads,
                    res.data[0].Branches,
                    res.data[0].Addresses,
                    res.data[0].Phone_Numbers,
                    res.data[0].Websites,
                    res.data[0].Emails,
                    res.data[0].People,
                ]));

                setSiteOptions(initBarOptions(10, ['Contact Forms', 'Forms w/o Captcha', 'Contact Page', 'About Page', 'Team Page', 'Careers Page', 'Inverstor Page', 'Product Page', 'Shopping Cart', 'Mobile App']));
                setSiteSeries(initBarSeries([
                    res.data[0].contactformcount,
                    res.data[0].contactformnccount,
                    res.data[0].contacturlcount,
                    res.data[0].abouturlcount,
                    res.data[0].leadershipurlcount,
                    res.data[0].careersurlcount,
                    res.data[0].investorurlcount,
                    res.data[0].producturlcount,
                    res.data[0].carturlcount,
                    res.data[0].mobileappscount
                ]));

                setSocialOptions(initBarOptions(20, ['Facebook', 'X/Twitter', 'Instagram', 'LinkedIn', 'YouTube', 'Pinterest', 'WhatsApp']));
                setSocialSeries(initBarSeries([
                    res.data[0].facebookurlcount,
                    res.data[0].twitterurlcount,
                    res.data[0].instagramurlcount,
                    res.data[0].linkedinurlcount,
                    res.data[0].youtubeurlcount,
                    res.data[0].pinteresturlcount,
                    res.data[0].whatsappturlcount
                ]));

                setPresenceOptions(initPresenceOptions(["High", "Medium", "Low", "None"]));
                setPresenceSeries(initPresenceSeries([
                    parseInt(res.data[0].High_Presence),
                    parseInt(res.data[0].Medium_Presence),
                    parseInt(res.data[0].Low_Presence),
                    parseInt(res.data[0].None_Presence)
                ]));

                setReputationOptions(initReputationOptions(["High", "Medium", "Low", "None"]));
                setReputationSeries(initReputationSeries([
                    parseInt(res.data[0].High_Reputation),
                    parseInt(res.data[0].Medium_Reputation),
                    parseInt(res.data[0].Low_Reputation),
                    parseInt(res.data[0].None_Reputation)
                ]));        
            } else if (isPeopleView) {
                setPeopleSumOptions(initBarOptions(30, ['People', 'Role', 'Phone', 'Email', 'LinkedIn']));
                setPeopleSumSeries(initBarSeries([
                    res.data[0].people_count,
                    res.data[0].role_count,
                    res.data[0].phone_count,
                    res.data[0].email_count,
                    res.data[0].linkedin_count,
                ]));

                setPeopleLvlOptions(initBarOptions(40, ['C Suite', 'Company Head', 'Senior Management', 'Company Leader', 'other']));
                setPeopleLvlSeries(initBarSeries([
                    res.data[0].lvl_c_suite,
                    res.data[0].lvl_company_head,
                    res.data[0].lvl_senior_management,
                    res.data[0].lvl_company_leader,
                    res.data[0].lvl_other,
                ]));

                setPeopleFunOptions(initBarOptions(50, ['Sales & Marketing', 'Technology', 'Engineering', 'Creative & Design', 'Accounting & Finance', 'HR & Talent Acquisition', 'Legal, Risk & Compliance', 'other']));
                setPeopleFunSeries(initBarSeries([
                    res.data[0].fun_sales_and_marketing,
                    res.data[0].fun_technology,
                    res.data[0].fun_engineering,
                    res.data[0].fun_creative_and_design,
                    res.data[0].fun_accounting_and_finance,
                    res.data[0].fun_hr_and_talent_acquisition,
                    res.data[0].fun_legal_risk_and_compliance,
                    res.data[0].fun_Other,
                ]));
            }
            props.ucd(false);
        })
        .catch((error) => {
          console.log(error);
          props.ucd(false);
        })     
        
        if (isCatalogView || isLeadsView) {
            props.ucd(true);
            axios.post(top10Url, { isUserCategoryGroup, filterCategoryGroup, filterMultipleCategories, filterCategory, filterCountry, filterState, selectedCategory, selectedState })
            .then(res => {
                var labels = [];
                var series = [];
                var treemapData = [];
                
                res.data.forEach(row => {
                    series.push(parseInt(row.Total_Leads));
                    labels.push(groupByCategory ? row.category_en : row.state);
                    treemapData.push({x: groupByCategory ? row.category_en : row.state, y: row.Total_Leads});
                });

                setPieOptions(initPieOptions(labels));
                setPieSeries(initPieSeries(series));
                setTreemapOptions(initTreemapOptions([]));
                setTreemapSeries(initTreemapSeries(treemapData));

                props.ucd(false);
            })
            .catch((error) => {
                console.log(error);
                props.ucd(false);
            })              
        }
    }, [props.key, props.catalog, props.state]) // , props.selectedOnly

    return (<>
        <div className="m-0 p-0 w-100 h-100 d-flex flex-column overflow-auto">
            {(isCatalogView || isLeadsView) ? (<>
            <div id="summary" title="Catalog Summary" className='m-0 p-2 w-100 border border-gray'>
                <div className="my-1 fs-5 fw-bold text-center" style={{width: "95%"}}>{isLeadsView ? 'Catalog Summary' : 'Summary'}</div>
                <Chart
                    type='bar'
                    options={barOptions}
                    series={barSeries}
                />
            </div>
            <div id="sitestats" title="Web Site Stats" className='m-0 p-2 w-100 border border-gray'>
                <div className="my-1 fs-5 fw-bold text-center" style={{width: "95%"}}>Web Site Stats</div>
                <Chart
                    type='bar'
                    options={siteOptions}
                    series={siteSeries}
                />
            </div>
            <div id="socialpresence" title="Social Presence" className='m-0 p-2 w-100 border border-gray'>
                <div className="my-1 fs-5 fw-bold text-center" style={{width: "95%"}}>Social Media Presence</div>
                <Chart
                    type='bar'
                    options={socialOptions}
                    series={socialSeries}
                />
            </div>
            <div id="top10" title={`Top 10 ${(top10Group === 'state') ? 'States/Territories' : 'Categories'}`} className='m-0 p-2 w-100 border border-gray'>
                <div className="ms-3 fs-5 fw-bold text-center" style={{width: "95%"}}>{`Top 10 ${(top10Group === 'state') ? 'States/Territories' : 'Categories'}`}</div>
                {/*
                <Chart
                    type='donut'
                    options={pieOptions}
                    series={pieSeries}
                    height="90%"
                />
                */}
                <Chart
                    type='treemap'
                    options={treemapOptions}
                    series={treemapSeries}
                />
            </div>
            {isLeadsView ? (<>
            <div id="pie-charts" className="m-0 p-0 w-100 d-flex flex-row" style={{height: "30%"}}>
                <div id="presence" title="Market Presence" className='p-2 w-50 border border-gray'>
                    <div className="my-1 fs-5 fw-bold text-center flex-fill" style={{width: "95%"}}>Market Presence</div>
                    <Chart
                        type='pie'
                        options={presenceOptions}
                        series={presenceSeries}
                    />
                </div>
                <div id="reputation" title="Reputation" className='p-2 w-50 border border-gray'>
                    <div className="my-1 fs-5 fw-bold text-center flex-fill" style={{width: "95%"}}>Reputation</div>
                    <Chart
                        type='pie'
                        options={reputationOptions}
                        series={reputationSeries}
                    />
                </div>
            </div>
            </>) : ''}
            </>) : (<>
            <div id="summary" title="Summary" className='m-0 p-2 w-100 border border-gray'>
                <div className="my-1 fs-5 fw-bold text-center" style={{width: "95%"}}>Summary</div>
                <Chart
                    type='bar'
                    options={peopleSumOptions}
                    series={peopleSumSeries}
                />
            </div>
            <div id="levels" title="Web Site Stats" className='m-0 p-2 w-100 border border-gray'>
                <div className="my-1 fs-5 fw-bold text-center" style={{width: "95%"}}>Levels</div>
                <Chart
                    type='bar'
                    options={peopleLvlOptions}
                    series={peopleLvlSeries}
                />
            </div>
            <div id="functions" title="Social Presence" className='m-0 p-2 w-100 border border-gray'>
                <div className="my-1 fs-5 fw-bold text-center" style={{width: "95%"}}>Functions</div>
                <Chart
                    type='bar'
                    options={peopleFunOptions}
                    series={peopleFunSeries}
                />
            </div>
            </>)}            
        </div>
    </>)
}

export default MCharts;